module.exports = __webpack_public_path__ + "images/emoji/eight_pointed_black_star.059cba73af49c95ebe18.png";